import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /*
   * Get User Profile
   */
  getUserProfile(): Observable<any> {
    return this.http.get(this.baseUrl + 'api/getUserProfile');
  }

  getRole(): boolean {
    const role = JSON.parse(localStorage.getItem('userInfo')!).role;
    if (role && role.name == 'COMPANY') {
      return false;
    } else {
      return true;
    }
  }
  getApplicantProfile(userId: string): Observable<any> {
    return this.http.get(this.baseUrl + `api/applicant/${userId}`);
  }
  /**
   * Update user profile — text fields + optional image/CV files.
   * Sends everything as multipart/form-data in one PATCH request.
   * Do NOT set Content-Type manually; Angular sets it with the correct boundary.
   */
  updateUserProfile(formData: FormData): Observable<any> {
    return this.http.patch(this.baseUrl + 'api/updateUserDetails', formData);
  }
}
